import { Box } from "@mui/material";

import { BreadcrumbHeaderListing, Title } from "../Header";
import { breadcrumbTitleSx } from "../dropdownMenuStyles";
import {
  DocumentModeBoundary,
  DocumentModeChrome,
} from "../../design/DocumentModeBoundary";

/**
 * Shell breadcrumb for the nine SectionDashboard module homes (Sales,
 * Directory, Tech Records, Maintenance, Purchasing, Stores, Finance, Safety &
 * Quality, System Admin — App.tsx's "Section Landing Dashboards" routes).
 *
 * These are tab-based homes (Overview + one tab per destination), not
 * mode-switched modules, so there is no dropdown — just the "<Module>" crumb.
 * Same no-dropdown shape as `src/reports/ReportLayout.tsx`, generalised with a
 * `title` prop instead of a hardcoded string so all nine can share it.
 *
 * Before this, these nine routes were mounted flat under `AppLayout` with no
 * `*Layout` wrapper, so `SectionDashboard` rendered its own `ListingHeader` —
 * documented as a deliberate deviation in REVIEW-phase3.md §3a, and the reason
 * these nine had no shell breadcrumb and no mode switcher. `SectionDashboard`
 * no longer renders `ListingHeader`; this layout is the replacement.
 * Nested Today intake temporarily yields this breadcrumb to the document
 * record. The workflow stays mounted while its enclosing chrome is hidden.
 */
export const SectionHomeLayout: React.FC<
  React.PropsWithChildren<{ title: string }>
> = ({ title, children }) => (
  <DocumentModeBoundary>
    <DocumentModeChrome>
      <BreadcrumbHeaderListing aria-label="breadcrumb">
        <Title sx={breadcrumbTitleSx}>{title}</Title>
      </BreadcrumbHeaderListing>
    </DocumentModeChrome>
    <Box sx={{ textAlign: "left" }}>{children}</Box>
  </DocumentModeBoundary>
);

export default SectionHomeLayout;
